import BaseApi from '../base'

const path = '/synergy/todo'
export default class DailyReportApi extends BaseApi {
  constructor() {
    super(path)
  }
  static GetInstance = () => new DailyReportApi()
  getTodoStatusList = () => this.get(`${path}/status`)
  getTodoPriorityList = () => this.get(`${path}/priority`)
}
